import React from 'react';
import {createStyles} from '../../../utils/createStyles';
import {
  Image,
  ImageBackground,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from 'react-native-vector-icons/SimpleLineIcons';
import {useNavigation} from '@react-navigation/native';
import {showConfirmDialog} from '../../../components/Dialog/ConfirmDialog';
import {logout} from '../../../request/token';
import {logoffApi} from '../../../API/user';
import Toast from 'react-native-toast-message';

export type SettingItem = {
  title: string;
  icon: string;
  path: string;
};

export default function SettingList(): React.JSX.Element {
  const navigation = useNavigation();
  const settingList: Array<SettingItem> = [
    {
      title: '家长管理',
      icon: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%20960.png',
      path: 'ParentBinding',
    },
    {
      title: '切换账号',
      icon: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%20959.png',
      path: 'ChangeUser',
    },
    {
      title: '退出登录',
      icon: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%20958.png',
      path: 'exitLogin',
    },
    {
      title: '修改密码',
      icon: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%20957.png',
      path: 'ForgetPassword',
    },
    {
      title: '注销账号',
      icon: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%20956.png',
      path: 'AccountCancellation',
    },
  ].filter(item => {
    if (Platform.OS === 'web') {
      return item.title === '退出登录';
    } else {
      return item;
    }
  });
  const onPress = (item: SettingItem) => {
    if (item.path === 'exitLogin') {
      showConfirmDialog({
        content: '是否确认退出当前账号？',
        confirmCallback: close => {
          logout().then(() => {
            close();
          });
        },
      });
    } else if (item.path === 'AccountCancellation') {
      showConfirmDialog({
        content: '注销后我们将永久删除账号及数据是否确认删除？',
        type: 'error',
        confirmText: '取消',
        cancelText: '确认',
        confirmButtonStyle: {
          color: '#333',
          backgroundColor: '#FFE6E6',
        },
        cancelButtonStyle: {
          color: '#fff',
          backgroundColor: ['#FF6666', '#FF5050'],
        },
        cancelCallback: close => {
          logoffApi().then(res => {
            if (res.status !== 200) {
              return Toast.show({
                type: 'error',
                text1: '注销失败',
              });
            }
            Toast.show({
              type: 'success',
              text1: '注销成功',
            });
            logout().then(() => {
              close();
            });
          });
        },
      });
    } else if (item.path) {
      // @ts-ignore
      navigation.navigate(item.path);
    }
  };
  return (
    <ImageBackground
      style={styles.flex1}
      source={require('../../../assets/images/userCenter/bg.png')}>
      {settingList.map((item, index) => {
        return (
          <TouchableOpacity
            activeOpacity={0.6}
            key={index}
            onPress={() => onPress(item)}
            style={styles.itemWrap}>
            <View style={styles.imgWrap}>
              <Image style={styles.iconImg} source={{uri: item.icon}} />
              <Text style={styles.iconText}>{item.title}</Text>
            </View>
            <Icon size={16} name="arrow-right" />
          </TouchableOpacity>
        );
      })}
    </ImageBackground>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemWrap: {
    width: '49%',
    height: '5.7rem',
    backgroundColor: '#fff',
    borderRadius: '1rem',
    marginBottom: '1.5rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '1.6rem',
    paddingRight: '2.5rem',
  },
  imgWrap: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconImg: {
    width: '4.7rem',
    height: '4.7rem',
    marginRight: '2.4rem',
  },
  iconText: {
    fontSize: '1.65rem',
    color: '#333333',
  },
});
